<template>
	<div>
		<h4 class="mb-3">{{ $t('who-are-you-importing') }}</h4>

		<b-form-group class="mb-3">
			<b-form-radio v-model="localUserType" value="student">{{ $t('students') }}</b-form-radio>
			<b-form-radio v-model="localUserType" value="teacher">{{ $t('teachers') }}</b-form-radio>
		</b-form-group>

		<b-button variant="primary" :disabled="!userType" @click="$emit('next')">
			{{ $t('next') }} →
		</b-button>
	</div>
</template>

<script>
export default {
	props: {
		userType: { type: String, default: null },
	},
	computed: {
		localUserType: {
			get()  { return this.userType; },
			set(v) { this.$emit('update:userType', v); },
		},
	},
};
</script>
